import { i18n } from '../i18n/translate.js';

// regex pattern needs to be a string and need to double escape the characters to avoid invalid regex error
var formValidations = {
  slug: {
    pattern: '^[a-z0-9-_]*$',
    message: i18n.t('Slug is invalid, should contain only lower case letters, number, dashes and underscores')
  },
  url: {
    pattern: '((http|https):\\/\\/)?(([a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]+)|((25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)(\\.(25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)){3}(:?[0-9]*)))(\\/.*)?',
    message: i18n.t('URLs must start with https:// or http:// and include at least one period.')
  },
  youtube: {
    pattern: '(?:https?:\\/\\/)?(?:www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:embed\\/|v\\/|watch\\?v=|watch\\?.+&v=))((\\w|-){11})(?:\\S+)?',
    message: i18n.t('Invalid YouTube URL.')
  },
  vimeo: {
    pattern: '(?:http|https)?:?\\/?\\/?(?:www\\.?player\\.)?vimeo\\.com\\/(?:channels\\/(?:\\w+\\/)?|groups\\/(?:[^\\/]*)\\/videos\\/|video\\/|)(\\d+)?\\/?(?:.*)?',
    message: i18n.t('Invalid Vimeo URL.')
  },
  video: {
    pattern: '(?:(?:(?:https?:\\/\\/)?(?:www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:embed\\/|v\\/|watch\\?v=|watch\\?.+&v=))((\\w|-){11})(?:\\S+)?)|(?:(?:http|https)?:?\\/?\\/?(?:www\\.?player\\.)?vimeo\\.com\\/(?:channels\\/(?:\\w+\\/)?|groups\\/(?:[^\\/]*)\\/videos\\/|video\\/|)(\\d+)?\\/?(?:.*)?))',
    message: i18n.t('Invalid video URL.')
  },
  email: {
    pattern: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.{1}[0-9]{1,3}\\.{1}[0-9]{1,3}\\.{1}[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    message: i18n.t('Please enter a valid email.')
  },
  tel: {
    pattern: '^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$',
    message: i18n.t('Invalid phone number - must be in (XXX) XXX-XXXX format.')
  },
  datetime: {
    pattern: '^(?:(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])|(3[01]|[12][0-9]|0[1-9])/(1[0-2]|0[1-9]))/[0-9]{4}(\\s[0-9]{1,2}:[0-9]{2}(:[0-9]{2})?)?(\\s(AM|PM))?$',
    message: i18n.t('Invalid date!')
  },
  email_domain: {
    pattern: '^([a-z0-9]+(-[a-z0-9]+)*.)+[a-z]{2,}$',
    message: i18n.t('Invalid email domain!')
  },
  integer: {
    message: i18n.t('Invalid value. Must be an integer.')
  },
  password: {
    // Minimum of 12 characters long, 1 upper and lower case, 1 number, 1 special character (!@#$%*)
    pattern: '(?=[A-Za-z0-9!@#$%*]+)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%*])(?=.{12,}).*',
    message: i18n.t('Minimum of 12 characters long, 1 upper and lower case, 1 number, 1 special character (!@#$%*)')
  },
  password_minimum_8: {
    // Minimum of 8 characters long, 1 upper and lower case, 1 number, 1 special character (!@#$%*)
    pattern: '(?=[A-Za-z0-9!@#$%*]+)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%*])(?=.{8,}).*',
    message: i18n.t('Minimum of 8 characters long, 1 upper and lower case, 1 number, 1 special character (!@#$%*)')
  },
  password_confirmation: {
    message: i18n.t('Password Confirmation must match Password')
  }
};

/**
 * Returns pattern from `formValidations` when passed a valid type,
 * Returns undefined if type and pattern are not defined
 * Returns `pattern` if `pattern` is defined
 *
 * @param {string|undefined} type Requested property from `formValidations`
 * @param {string|undefined} pattern if not undefined, `pattern` is returned
 */
var GetValidationPattern = function GetValidationPattern(type) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (type && !pattern) {
    return formValidations[type.toLowerCase()] ? formValidations[type.toLowerCase()].pattern : pattern;
  } else {
    return pattern;
  }
};
var GetValidationMessage = function GetValidationMessage(type) {
  return formValidations[type.toLowerCase()].message;
};

// TODO: Add test case once converted to Jest/RTL
var isEqualLowerCase = function isEqualLowerCase(string1, string2) {
  return (string1 === null || string1 === void 0 ? void 0 : string1.toLowerCase()) === (string2 === null || string2 === void 0 ? void 0 : string2.toLowerCase());
};
export { GetValidationMessage, GetValidationPattern, isEqualLowerCase };